import { createServerFn } from '@tanstack/react-start';
import api from '../utils/api';
import { filterActiveSafari } from '../utils/photoUtils';

export const getHandPickedSafaris = createServerFn()
    .handler(async ({ data }) => {
        const response = await api('get', 'safaris/main', { destination: data.destination, limit: data.limit });
        const resData = response.data;
        if (Array.isArray(resData)) {
            return resData.map(filterActiveSafari);
        }
        return resData;
    });